export const ITEM_PRICE_TYPE = {
    FIXED_PRICE: 'FIXED_PRICE',
    VARIABLE_PRICE: 'VARIABLE_PRICE',
    RANGED_PRICE: 'RANGED_PRICE',
} as const;

export type ItemPriceType =
    (typeof ITEM_PRICE_TYPE)[keyof typeof ITEM_PRICE_TYPE];

export interface UnitPrice {
    unitId: string;
    sellPrice: number;
    maxSellPrice?: number | null;
    margin?: number | null;
}

export interface PricingGroupUnitPrice {
    unitId: string;
    groupSellPrice: number;
    minQuantity: number | null;
}

export interface MappedItemVariantResponse {
    id: string;
    name: string;
    sku: string | null;
    barcode: string | null;
    itemPriceType: ItemPriceType;
    sellPrice: number | null;
    maxSellPrice?: number | null;
    costPrice: number | null;
    autoApplyPriceTier: boolean;
    deleted: boolean;
    compositions: MappedItemVariantCompositionResponse[];
    stockDetail: StockDetail | null;
    pricingGroups?: ItemVariantPricingGroup[] | null;
    unitPrices: UnitPrice[];
}

export const STOCK_STATUS = {
    OUT_OF_STOCK: 'OUT_OF_STOCK',
    LOW_STOCK: 'LOW_STOCK',
    OPTIMAL_STOCK: 'OPTIMAL_STOCK',
    IN_STOCK: 'IN_STOCK',
} as const;

export type StockStatus = (typeof STOCK_STATUS)[keyof typeof STOCK_STATUS];

export interface ItemVariantPricingGroup {
    id: string;
    groupId: string;
    deleted: boolean;
    sellPrice: number;
    minQuantity: number | null;
    unitPrices?: PricingGroupUnitPrice[];
}

export interface StockDetail {
    currentStock: number;
    lowStockAlert: number;
    status: StockStatus;
}

export interface MappedItemVariantCompositionResponse {
    id: string;
    variantId: string;
    quantity: number;
    deleted: boolean;
}
